// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1z41g","left":"InfoRow_left__1IG3o"};